
import { Component, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { Action, Getter } from 'vuex-class'
import {
    getCompanyAddressInfo,
    getPreOrderInfo,
    GetPreOrderInfoParamsDto,
    PreOrderInfoListDto, PreOrderListDto, ShopAddressListDto, submitPurchaseOrder,
    SubmitPurchaseOrderDto
} from '@/api/buyCar'
import AppendixDialog from '@/views/orderManage/template/AppendixDialog.vue'
import { AppendixFileDto } from '@/api/commonConfig'
import AppendixName from '@/components/AppendixName/index.vue'
import { Debounce } from '@/core/decorator'

@Component({
    name: 'SubmitOrder',
    components: {AppendixDialog, AppendixName}
})
export default class SubmitOrder extends Vue {
    @Getter companyId!: string
    @Getter providerId!: string
    @Getter preOrderParams!: GetPreOrderInfoParamsDto
    @Action setOrderDtlList!: (val: PreOrderListDto) => void

    labelWidth = 80
    showCalendar = false
    remark = ''
    orderData: PreOrderInfoListDto = {}
    submitData: SubmitPurchaseOrderDto = {
        customerId: '',
        cartFlag: false,
    }
    addressInfo: ShopAddressListDto = {
        isDefault: 0
    }
    currentOrderIndex!: number // 当前操作的订单下标

    isSubmit = false

    created () {
        this.submitData.customerId = this.companyId
        this.submitData.cartFlag = this.$route.query.cartFlag === '1' // 是否是从购物车页面进入， ’1‘是， ’‘否
        this.getData()
        this.getAddressInfo()
    }

    /* 获取提交订单信息 */
    getData () {
        getPreOrderInfo(this.preOrderParams).then((res) => {
            this.orderData = res.data || {}
            /* 数据格式化为提交数据的数据格式 */
            const orderList = this.orderData.orderList || []
            this.submitData.orderList = orderList.map((item) => {
                return {
                    companyId: item.shopId,
                    deliveryDate: '',
                    orderRemark: '',
                    orderDtlList: item.purchaseOrderDtlList.map((goods) => {
                        return {
                            versionId: goods.versionId,
                            goodsId: goods.goodsId,
                            setmealId: goods.packageId,
                            saleAmount: goods.saleAmount,
                        }
                    })
                }
            })
            this.submitData = JSON.parse(JSON.stringify(this.submitData))
        })
    }

    /* 获取地址信息 */
    getAddressInfo () {
        getCompanyAddressInfo({companyId: this.companyId}).then((res) => {
            if (res.data.addressList && res.data.addressList.length > 0) {
                const list = res.data.addressList.filter((item) => item.isDefault)
                if (list && list.length > 0) {
                    this.addressInfo = list[0]
                    this.submitData.receiveAddress = this.addressInfo.addressId
                    this.submitData.receiveAddressDtl = this.addressInfo.addressDtl
                    this.submitData.receiveMobile = this.addressInfo.receiveMobile
                    this.submitData.receiveMan = this.addressInfo.receiveMan

                } else {
                    this.addressInfo = {}
                    this.submitData.receiveAddress = ''
                    this.submitData.receiveAddressDtl = ''
                    this.submitData.receiveMobile = ''
                    this.submitData.receiveMan = ''
                }
            }
        })
    }

    /* 显示选择日期弹窗 */
    showCalendarDialog (index: number) {
        this.showCalendar = true
        this.currentOrderIndex = index
    }

    /* 确认选择日期 */
    onConfirmData (date) {
        const dateFlag = `${dayjs(date).format('YYYY-MM-DD')}`
        this.submitData.orderList[this.currentOrderIndex].deliveryDate = dateFlag
        this.showCalendar = false
    }

    /* 套餐清单 */
    toMerchBill (data: PreOrderListDto) {
        this.setOrderDtlList(data)
        this.$router.push('/merchBill')
    }

    /* 显示上传附件弹窗 */
    showUploadFunc (index: number) {
        this.currentOrderIndex = index
        const data = this.submitData.orderList[this.currentOrderIndex]
        ;(this.$refs.appendixDialog as any).show({
            fileType: '6',
            orderFile: data.orderFileList
        })
    }

    /* 获取上传附件信息 */
    getUploadInfo (data: AppendixFileDto[]) {
        this.$set( this.submitData.orderList[this.currentOrderIndex],'orderFileList',data)
    }

    /* 提交订单 */
    @Debounce(500)  // 防抖
    submitOrder () {
        if (!this.submitData.receiveAddress) {
            return this.$toast('请先选择收货地址')
        }
        if (this.isSubmit) return false // 防止用户触发多次提交误点
        this.isSubmit = true
        submitPurchaseOrder(this.submitData).then((res) => {
            if (res.code === '000000') {
                this.$router.replace({
                    path: '/submitSuccess',
                    query: {
                        resultList: res.data
                    }
                })
            } else if (res.code === '000002') {
                const data = res.data
                if (data.rejectType === 'NonOrderable' || data.rejectType === 'InvalidGoods') {
                    this.$dialog.alert({
                        message: `${data.goodsName}商品过期不存在`
                    }).then(() => {
                        //  刷新当前页面
                        this.getData()
                        this.getAddressInfo()
                    })
                } else if (data.rejectType === 'InvalidPackage') {
                    this.$dialog.alert({
                        message: `${data.goodsName}商品所选规格过期不存在，请重新选择`
                    }).then(() => {
                        //  返回上一界面并刷新
                        this.$router.back()
                        window.sessionStorage.setItem('refresh', '1')
                    })
                }
            }
        }).catch(() => { }).finally(() => this.isSubmit = false)
    }

    // 调用原生enterSelectAddress方法去选择收获地址
    toSelectAddress () {
        const data = {
            customerId: this.companyId,
            isShowTemporary: false, // 是否展示临时地址信息 传false就是不展示，true就是展示
            title: '收货地址管理'
        }
        this.$bridge.callHandler('enterSelectAddress', {data}, (res) => {
            const data = !res ? {} : JSON.parse(res)
            this.addressInfo = data
            this.submitData.receiveAddress = this.addressInfo.addressId
            this.submitData.receiveAddressDtl = this.addressInfo.addressDtl
            this.submitData.receiveMobile = this.addressInfo.receiveMobile
            this.submitData.receiveMan = this.addressInfo.receiveMan
        })
    }

}
